/** Opacity / mix weights for live-map status chip pastel styling. */
export const LIVE_MAP_CHIP_COLOR_MIX_WEIGHTS = {
  border: 38,
  background: 14,
  shadow: 22,
  focusOutline: 55,
  plannedForNowOnBackground: 24,
  plannedForNowOnShadow: 28,
} as const;
